import initModals from './components/modal';
import initAppearAnim from "./utils/appear-anim";
import initDropdown from "./utils/dropdown";
import initTabs from './utils/tabs';
// import initReadMore from './utils/read-more';
import initHeaderNavigation from './template-parts/header-navigation';
import { initYoutubeIframe } from './components/youtube-iframe';
import { initSearchAutocomplete, initSearchReset } from './template-parts/search';
import initSingleContentSummary from './template-parts/single-content-summary';
import initFormulaireCF7Redirection from './utils/formulaireCF7redirection';
import initFormulaireCF7Confirmation from './utils/formulaireCF7confirmation';
import initCarouselPosts from './components/carousel-posts';
import initDropdownGrid from './utils/dropdown-grid';
import initMaillageContenu from './blocks/maillage-contenu';
import initMaillageFormations from './blocks/maillage-formations';
import initSearchAgenceForm from './components/form-search-agence';
import initTestimonialsTabs from './blocks/testimonials-tabs';
import initObfuscateLink from './utils/obfuscate-link';
import initWrapperLink from './utils/wrapper-link';
import initAvisListeForm from './blocks/avis-liste';
import initTransformToAccordion from './utils/transform-to-accordion';
import initSimpleSwiper from './utils/simple-swiper';
import initScrollLogos from './blocks/liste-logos';
import initOpportunities from './blocks/opportunities';
import initMaillageAvis from './blocks/maillage-avis';
import initStepper from './blocks/stepper';
import initContactForm from './blocks/contact';
import initInputFile from './components/input-file';
import initPushConseil from './blocks/push-conseil';
import initReadmoreToggle from './components/readmore-toggle';
import initSearchSuggestionsAutocomplete from './components/form-search-suggestions-autocomplete';
import initBannerNews from './components/banner-news';
import initTextExpand from './blocks/text-expand';
import initBlockquoteTemoignage from './components/blockquote-temoignage';
import initBlogLinkTargeter from './components/blog-link-targeter';
import initMainLinkTargeter from './components/main-link-targeter';
import initExpand from './components/expand';
import initHeaderQuizz from './blocks/header-quizz'

// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);

// Utils
initAppearAnim();
initDropdown();
initTabs();
// initReadMore();
initFormulaireCF7Redirection();
initFormulaireCF7Confirmation();
initDropdownGrid();
initObfuscateLink();
initWrapperLink();
initTransformToAccordion();
initSimpleSwiper();

// Template parts
initHeaderNavigation();
// initSearchNbPerPageSelect();
initSearchAutocomplete();
initSearchReset();
initSingleContentSummary();

// Blocks
initMaillageContenu();
initMaillageFormations();
initMaillageAvis();
initTestimonialsTabs();
initAvisListeForm();
initScrollLogos();
initOpportunities();
initStepper();
initContactForm();
initPushConseil();
initTextExpand();
initHeaderQuizz();

// Components
initModals();
initYoutubeIframe();
initCarouselPosts();
initSearchAgenceForm();
initInputFile();
initReadmoreToggle();
initSearchSuggestionsAutocomplete();
initBannerNews();
initBlockquoteTemoignage();
initBlogLinkTargeter();
initMainLinkTargeter();
initExpand();

